import { toTask } from '@execonline-inc/maybe-adapter';
import { putQueryParam, toUrlT, URLParser } from '@execonline-inc/url';
import { Maybe } from 'maybeasy';
import { Task } from 'taskarian';
import { callApi } from '../../../../../../Appy';
import { Link } from '../../../../../../Resource/Types';
import { filterOptionsResourceDecoder } from './Decoder';
import { setFilteredState, warnAndSetErrorState } from './Actions';
import { FilterError, Loading, NewState } from './Types';
import { StringOption } from '../../../../../Options/Types';
import { Filtering } from '../../../../../LearningCollections/LearningCollection/ParticipantDynamicTypeaheadSelect/UseParticipantDynamicTypeaheadSelect/Types';

const addParamsToUrl = (state: Filtering | Loading) => (url: URLParser) => {
  switch (state.kind) {
    case 'loading':
      return state.initialValue
        .map(({ value }) => putQueryParam(`filter[id]`, value, url))
        .getOrElseValue(url);
    case 'filtering':
      return putQueryParam(`filter[query]`, state.filterBy, url);
  }
};

const urlTask = (endpoint: Link, state: Loading | Filtering): Task<FilterError, Link> =>
  toUrlT(endpoint.href)
    .map(addParamsToUrl(state))
    .map((url) => ({
      rel: endpoint.rel,
      href: url.href,
      method: endpoint.method,
      type: endpoint.type,
    }));

export const fetchOptionsReaction = (
  endpoint: Link,
  state: Loading | Filtering,
  setState: (value: NewState) => void,
) =>
  urlTask(endpoint, state)
    .andThen(callApi(filterOptionsResourceDecoder, {}))
    .fork(warnAndSetErrorState(setState), setFilteredState(state, setState));

export const loadingReaction = (
  endpoint: Link,
  state: Loading | Filtering,
  setState: (value: NewState) => void,
  initialValue: Maybe<StringOption>,
) =>
  toTask('no initial value to load', initialValue).fork(
    () => setState({ kind: 'ready' }),
    () => fetchOptionsReaction(endpoint, state, setState),
  );
